@if (initialized) {

        <div class="">
            <dc-page-search></dc-page-search>
        </div>
}
